export default "__VITE_ASSET__ae452964__"